module.exports = {
  feedback: {
    title: "提问",
    requiredParams: {},
    optionalParams: {
      questionId: "", //知识点或者试题id,
      type: null, //1试题2、知识点3、其他
      knowledgeName: "" //知识点名称
    }
  },
  myFeedback: {
    title: "我的提问",
    requiredParams: {},
    optionalParams: {}
  },
  onlineDetail: {
    title: "问题详情",
    requiredParams: {},
    optionalParams: {}
  },
  onlineIndex: {
    title: "专业答疑",
    requiredParams: {},
    optionalParams: {
      questionId: "", //知识点或者试题id,
      type: null, //1试题2、知识点3、其他
      knowledgeName: "" //知识点名称
    }
  },
  onlineResult: {
    title: "提交结果",
    requiredParams: {},
    optionalParams: {}
  }
};
